<template>
    <div class="reports-header">
        <div class="reports-header__bar">
            <span class="reports-header__bar__title">
                {{ t('reports.title') }}
            </span>
            <ReportsExportModal>
                <ReportsExportSection v-if="canExportReports" />
            </ReportsExportModal>
        </div>
        <ReportsComponentSelector
            :model-value="reportParams"
            @update:model-value="onTransformerValueUpdate"
        />
    </div>
</template>
<script setup lang="ts">
import ReportsComponentSelector from '@/pages/reports/view-all-reports-page/ReportsComponentSelector.vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ReportParams } from '@/types/reports'
import { REPORTS_PARAMS_KEY } from '@/utils/reports-utils'
import ReportsExportSection from '@/pages/reports/view-all-reports-page/sections/ReportsExportSection.vue'
import ReportsExportModal from '@/pages/reports/export/ReportsExportModal.vue'
import { usePermissions } from '@/composables/usePermissions'
import { computed } from 'vue'

defineProps<{
    reportParams: ReportParams
}>()

const { t } = useI18n()
const router = useRouter()
const { userPermissions } = usePermissions()

const canExportReports = computed(() => userPermissions.value.canExportTransformerReports || userPermissions.value.canExportGeneratorReports)

const onTransformerValueUpdate = (params: ReportParams) => {
    localStorage.setItem(REPORTS_PARAMS_KEY, JSON.stringify(params))
    router.replace({
        name: 'Reports_ViewAll',
        query: params,
    })
}
</script>

<style scoped lang="scss">
.reports-header {
    @include spacing-page;

    display: flex;
    flex-direction: column;
    gap: $spacing-m;

    background-color: $pbl-foreground;
    border-bottom: 1px solid $pbl-border-muted;

    &__bar {
        display: flex;
        align-items: center;
        gap: 48px;

        &__title {
            font-size: 1.25rem;
            font-weight: 500;
        }
    }
}
</style>
